import { render, staticRenderFns } from "./alumnItem.vue?vue&type=template&id=bbd5c026&scoped=true&"
import script from "./alumnItem.vue?vue&type=script&lang=js&"
export * from "./alumnItem.vue?vue&type=script&lang=js&"
import style0 from "./alumnItem.vue?vue&type=style&index=0&id=bbd5c026&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bbd5c026",
  null
  
)

export default component.exports